import React, { useEffect, useState } from "react";
import { ReactComponent as ScheduleIcon } from "../../../../assets/icons/ScheduleIcon.svg";
import { ReactComponent as DescriptionIcon } from "../../../../assets/icons/DescriptionIcon.svg";
import { ReactComponent as FlightIcon } from "../../../../assets/icons/FlightIcon.svg";
import { ReactComponent as PeopleOutlineIcon } from "../../../../assets/icons/PeopleOutlineIcon.svg";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { ReactComponent as HomeIcon } from "../../../../assets/icons/HomeIcon.svg";
import { ReactComponent as EqualizerIcon } from "../../../../assets/icons/EqualizerIcon.svg";
import { ReactComponent as AgentIcon } from "../../../../assets/icons/AgentIcon.svg";
import { ReactComponent as EmployesIcon } from "../../../../assets/icons/EmployesIcon.svg";
import { ReactComponent as SettingsIcon } from "../../../../assets/icons/settingIcon.svg";
import useStyles from "./sub-topbar-menu.styles";
import IconNavLink from "app/main/shared-components/icon-nav-link/IconNavLink";
import { ROLES } from "app/constants/roles";
import { useTranslation } from "react-i18next";
import useAuthority from "../../../hooks/useAuthority";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../store";

const SubTopbarMenu = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const scopes = useSelector(
    (state: AppState) => state.account.account.account?.scopes,
  );
  const { hasUserAnyAuthority } = useAuthority();
  const [hasButton, setHasButton] = useState(false);

  const isAdmin = hasUserAnyAuthority([ROLES.ROLE_ADMIN]);
  const isAgent = hasUserAnyAuthority([ROLES.ROLE_AGENT]) && !isAdmin;
  useEffect(() => {
    FlightReservation();
  }, [scopes]);

  const FlightReservation = () => {
    if (scopes && hasUserAnyAuthority([ROLES.ROLE_SUB_AGENT])) {
      scopes.map((x: any) => {
        if (x === "FLIGHT_RESERVATION") setHasButton(true);
      });
    }
    if (scopes && hasUserAnyAuthority([ROLES.ROLE_AGENT])) {
      scopes.map((x: any) => {
        if (x === "FLIGHT_RESERVATION") setHasButton(true);
      });
    }
    if (scopes && hasUserAnyAuthority([ROLES.ROLE_CALL_AGENT])) {
      scopes.map((x: any) => {
        if (x === "FLIGHT_RESERVATION") setHasButton(true);
      });
    }
    if (scopes && hasUserAnyAuthority([ROLES.ROLE_ADMIN])) setHasButton(true);
  };

  return (
    <div className={classes.root}>
      <div style={{ display: "flex" }}>
        <IconNavLink
          to="/dashboard"
          title={t("app.main.layout.subTopBar.title1", "DASHBOARD")}
          iconComponent={<HomeIcon />}
        />

        {hasButton ? (
          <IconNavLink
            to="/schedule"
            title={t("app.main.layout.subTopBar.title2", "SCHEDULE")}
            iconComponent={<ScheduleIcon />}
          />
        ) : (
          false
        )}

        <IconNavLink
          to="/schedules"
          title={t("app.main.layout.subTopBar.title3", "SCHEDULES")}
          iconComponent={<DescriptionIcon />}
        />
        <IconNavLink
          to="/flights"
          title={t("app.main.layout.subTopBar.title4", "FLIGHTS")}
          iconComponent={<FlightIcon />}
        />
        <IconNavLink
          to="/reports"
          title={t("app.main.layout.subTopBar.title5", "REPORTS")}
          iconComponent={<EqualizerIcon />}
          authorities={[ROLES.ROLE_ADMIN]}
        />
        <IconNavLink
          title={t("app.main.layout.subTopBar.title9", "AGENCY REPORTS")}
          to="/agency-reports"
          iconComponent={<EqualizerIcon />}
          authorities={[ROLES.ROLE_AGENT, ROLES.ROLE_SUB_AGENT]}
        />
        <IconNavLink
          to="/employees"
          title={t("app.main.layout.subTopBar.title6", "EMPLOYEES")}
          iconComponent={<EmployesIcon />}
          authorities={[ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER]}
        />
        <IconNavLink
          to="/customer"
          title={t("app.main.layout.subTopBar.title7", "CLIENTS")}
          iconComponent={<PeopleOutlineIcon />}
          authorities={[ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER]}
        />
        <IconNavLink
          to="/agents-agencies"
          title={
            isAgent
              ? t("app.main.layout.subTopBar.title11", "SUB-AGENTS")
              : t("app.main.layout.subTopBar.title8", "AGENTS")
          }
          iconComponent={<AgentIcon />}
          authorities={[
            ROLES.ROLE_ADMIN,
            ROLES.ROLE_CUSTOMER,
            ROLES.ROLE_AGENT,
            ROLES.ROLE_CALL_AGENT,
          ]}
        />

        <IconNavLink
          to="/sale/list"
          title={t("BMT NETWORK")}
          iconComponent={<TrendingUpIcon />}
          authorities={[ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER]}
        />

        <IconNavLink
          to="/coupons/promotional"
          title={t("app.main.layout.subTopBar.titleCoupons", "COUPONS")}
          iconComponent={<LocalOfferIcon />}
          authorities={[ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER]}
        />
      </div>

      <div>
        <IconNavLink
          to="/configurations"
          title={t("app.main.configuration.sidebar.title5", "SETTINGS")}
          iconComponent={<SettingsIcon />}
          authorities={[ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER]}
        />
      </div>
    </div>
  );
};

export default SubTopbarMenu;
